module.exports = __webpack_public_path__ + "static/media/glyph-icons2.d07829d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/frontend/client/shared/images/glyph-icons2.png
// module id = 781
// module chunks = 0